import debounce from 'lodash.debounce';

import { TUser } from '@cloud-wave/neon-common-lib';

import { LogEvents, logger } from 'lib/common/components/LoggerController';

import { TConfig } from 'lib/common/types/Config';
import TFetch from 'lib/common/types/Fetch';

const STORE_DEBOUNCE_MS = 300;

// When next status is set, we get 2 requests at simultaneously
// As a result, depending on the order of execution, we can end up with
// the wrong status. Debouncing the store status call ensures that we only store the latest status.
const debouncedStoreAgentStatus = debounce(
  async ({
    directoryStatus,
    onContact,
    billingStatus,
    fetch_,
    config,
  }: {
    directoryStatus: string;
    onContact: TUser['onContact'];
    billingStatus: string;
    fetch_: TFetch;
    config: TConfig;
  }) => {
    if (!config || !Object.keys(config).length || !fetch_) {
      return;
    }

    try {
      await fetch_(`${config.AGENT_SERVICE_URL}/agent/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ directoryStatus, onContact, billingStatus }),
      });
    } catch (error) {
      logger.error(LogEvents.AGENT_STATUS_UPDATE_FAILED, { error });
    }
  },
  STORE_DEBOUNCE_MS
);

export default debouncedStoreAgentStatus;
